/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React from 'react';
import { FlowBlockHeadline as HeadlineBlockModel } from '@staffino/model';
import { Headline } from '@staffino/primitive-controls';
import headlineBlockProps from './headline-block-props';

type Props = {
  block: HeadlineBlockModel;
};
function HeadlineBlock({ block }: Props) {
  return (
    <Headline
      {...headlineBlockProps(block)}
      textAlign="center"
      color={block.color ?? 'headline'}
    >
      {block.text}
    </Headline>
  );
}

export default HeadlineBlock;
